import { render, staticRenderFns } from "./_Total.vue?vue&type=template&id=9b0e1832"
import script from "./_Total.vue?vue&type=script&lang=js"
export * from "./_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports